export default __webpack_public_path__ + "static/media/153.68a26de7.jpg";